type CurrentUserRefreshHandler = () => Promise<void>

let refreshHandler: CurrentUserRefreshHandler | null = null
let refreshInProgress = false

export const subscribeToCurrentUserRefresh = (handler: CurrentUserRefreshHandler) => {
    refreshHandler = handler

    return () => {
        if (refreshHandler === handler) {
            refreshHandler = null
        }
    }
}

export const requestCurrentUserRefresh = () => {
    if (!refreshHandler || refreshInProgress) {
        return
    }

    refreshInProgress = true
    Promise.resolve(refreshHandler())
        .catch(() => {})
        .finally(() => {
            refreshInProgress = false
        })
}
